/**
 * api 接口
 */

const demo1 = "/rsgcg";

const userApi = {
  demo1_cityList: demo1 + "/venue/getCityList",
  
  demo1_getVenueGoodsList: demo1 + "/venue/getGoodsList",
  
  demo1_getVenueGoodsInfo: demo1 + "/venue/getGoodsInfo",
  
  demo1_getVenueGoodsStocks: demo1 + "/venue/getGoodsStocks",
  
  demo1_sendMobileCode: demo1 + "/login/sendMobileCode",
  
  demo1_login: demo1 + "/login/login",
  
  demo1_getCourseList: demo1 + "/api/course/getCourseList",
  
  demo1_getCourseGoodsTimetablesByDate: demo1 + "/api/course/getCourseGoodsTimetablesByDate",
  
  demo1_user_info: demo1 + "/user/info",
  
  
  demo1_create_order: demo1 + "/booking/create",
  demo1_bookingList: demo1 + "/booking/bookingList",
  demo1_cancel: demo1 + "/booking/cancel",
  
  
};

export default {
  userApi
};



// WEBPACK FOOTER //
// ./src/request/api.js